const getCookie = (cookieName: any) => document.cookie.split(';').find((item) => item.includes(cookieName));

export default getCookie;
